import { useState } from "react";
import { toast } from "sonner";
import { Download, Users, FileText, Wrench, ListChecks, CreditCard, UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { Card, Btn } from "../AdminUI";

const KINDS = [
  { kind: "customers", label: "Customers", icon: Users },
  { kind: "leads", label: "Leads", icon: UserPlus },
  { kind: "quotes", label: "Quotes", icon: FileText },
  { kind: "jobs", label: "Jobs", icon: Wrench },
  { kind: "tasks", label: "Follow-Ups", icon: ListChecks },
  { kind: "financing", label: "Financing", icon: CreditCard },
];

export default function DataExport() {
  const [busy, setBusy] = useState("");
  const download = async (kind) => {
    setBusy(kind);
    try {
      const r = await api.get(`/admin/export/${kind}`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "text/csv" }));
      const a = document.createElement("a"); a.href = url; a.download = `${kind}.csv`; a.click();
      URL.revokeObjectURL(url); toast.success(`${kind}.csv downloaded`);
    } catch (e) { toast.error(e.response?.data?.detail || "Export failed"); }
    finally { setBusy(""); }
  };
  return (
    <div className="space-y-6">
      <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">Data Export</h1>
      <Card title="Download CSV Exports">
        <p className="text-sm text-gray-500 mb-4">Export CRM data for backup or analysis. Available to Super Admin only.</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {KINDS.map(({ kind, label, icon: Icon }) => (
            <button key={kind} onClick={() => download(kind)} disabled={busy === kind}
              className="flex flex-col items-center gap-2 p-5 rounded-xl border border-gray-200 hover:border-[var(--action)] hover:bg-gray-50 transition-colors disabled:opacity-50"
              data-testid={`export-${kind}`}>
              <Icon className="w-6 h-6 text-[var(--navy)]" />
              <span className="text-sm font-semibold text-[var(--navy)]">{label}</span>
              <span className="text-[11px] text-[var(--action)] flex items-center gap-1"><Download className="w-3 h-3" /> {busy === kind ? "Exporting…" : "Download CSV"}</span>
            </button>
          ))}
        </div>
      </Card>
    </div>
  );
}
